import { useEffect, useState } from "react";
import axios from "axios";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Stack,
  Divider,
  Paper,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useTheme } from "@mui/material";
import { API_URL } from "../../../../constants";
import { useAuth } from "../../../../provider";
import { useTranslation } from "../../../../language";

export default function FobTest() {
  const { state } = useAuth();
  const userId = state.user.id;
  const theme = useTheme();
  const { t } = useTranslation();

  const [fob, setFob] = useState([]);
  const url_fob = `${API_URL}/measurements/${userId}/FOB/`;

  /* -------------------- API Call -------------------- */
  useEffect(() => {
    const fetchFOB = async () => {
      try {
        const res = await axios.get(url_fob);
        setFob(res.data || []);
      } catch (err) {
        console.error("Data Fetch failed:", err.response?.data || err);
      }
    };
    fetchFOB();
  }, [url_fob]);

  /* -------------------- Status Config -------------------- */
  const statusMap = {
    negative: {
      label: t("fobstatus_negative"),
      color: theme.palette.traffic.green,
    },
    positive: {
      label: t("fobstatus_positive"),
      color: theme.palette.traffic.red,
    },
  };

  /* -------------------- Styles -------------------- */
  const baseCardStyles = {
    width: { xs: 380, sm: 400, md: 400, lg: 500, xl: 540 },
    borderRadius: 4,
  };

  const cardStyles =
    theme.palette.mode === "light"
      ? { bgcolor: "grey.C50", borderColor: "grey.C900" }
      : {
          bgcolor: "greydark.C900",
          borderColor: "greydark.C400",
          backdropFilter: "blur(20px)",
          WebkitBackdropFilter: "blur(20px)",
        };

  /* -------------------- Render -------------------- */
  return (
    <Card variant="outlined" sx={{ ...baseCardStyles, ...cardStyles, mt: 4 }}>
      <CardContent>
        {/* Header */}
        <Stack direction="row" justifyContent="space-between" mb={3}>
          <Box>
            <Typography variant="caption" fontWeight={500}>
              {t("fob_title_overline")}
            </Typography>
            <Typography variant="h6" fontWeight={600}>
              {t("fob_title")}
            </Typography>
          </Box>
        </Stack>

        <Divider sx={{ my: 3 }} />

        {/* Explanation */}
        <Box mb={3}>
          <Typography variant="h6" fontWeight={400} gutterBottom>
            {t("fob_title_explain")}
          </Typography>
          <Typography variant="subtitle2" fontWeight={400}>
            {t("fob_body_explain")}
          </Typography>

          <Typography variant="h6" fontWeight={400} gutterBottom sx={{ mt: 4 }}>
            {t("fob_title_explain2")}
          </Typography>
          <Typography variant="subtitle2" fontWeight={400}>
            {t("fob_body_explain2")}
          </Typography>
        </Box>

        <Divider sx={{ my: 3 }} />

        {/* Results Table */}
        <Box sx={{my:4}}>
          <Typography variant="h6" fontWeight={500} gutterBottom >
            {t("fob_title_result")}
          </Typography>

          <TableContainer component={Paper} sx={{ mt: 4, bgcolor: theme.palette.mode === 'light' ? 'grey.C100' : 'greydark.C800' }}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>
                      <Typography variant="subtitle1" sx={{fontWeight:600}}> {t("fobDate")} </Typography>
                  </TableCell>
                  <TableCell>
                     <Typography variant="subtitle1" sx={{fontWeight:600}}> {t("fobResult")} </Typography>
                    </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {fob
                  .slice()
                  .sort((a, b) => new Date(b.date) - new Date(a.date))
                  .map((row) => {
                    const value = parseFloat(row.value);
                    const isValid = !isNaN(value);

                    const status = isValid && value < 100 ? "negative" : "positive";
                    const { label, color } = statusMap[status];

                    return (
                      
                      <TableRow key={row.id}>
                        
                        <TableCell>
                          <Typography variant="subtitle2" sx={{fontWeight:500}}>{new Date(row.date).toLocaleDateString()}</Typography>
                        </TableCell>

                        <TableCell>
                          <Chip
                            label={label}
                            sx={{
                              px:1.5,
                              bgcolor: color,
                              color: theme.palette.getContrastText(color),
                              fontWeight: 500,
                              fontSize: '1.4em',
                            }}
                          />
                        </TableCell>

                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </CardContent>
    </Card>
  );
}